// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__13IGq","vLegacy":"SelectSecondary_vLegacy__1rHJQ","error":"SelectSecondary_error__QEx-k","disabled":"SelectSecondary_disabled__847Xy"};